<template>
  <div class="pa-4">
    <CodeHighlight :code="code" />
  </div>
</template>

<script>
import CodeHighlight from '@/modules/codehl/CodeHighlight.vue';

export default {
  components: {
    CodeHighlight,
  },
  data() {
    return {
      code: `// ..
mounted() {
  window.addEventListener('scroll', this.onScroll)
},
beforeDestroy() {
  window.removeEventListener('scroll', this.onScroll)
},
methods: {
  onScroll() {
    this.text = '上拉了... 但是没触底'
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    if (scrollTop + clientHeight >= scrollHeight - 50) { 
      // 触底后操作
      // ps: 建议加防抖
      this.text = '触底了 开始加载'
      setTimeout(() => {
        this.text = '加载完了'
        this.num += 10
        setTimeout(() => {
          this.text = '焯...'
        }, 2000)
      }, 2000)
    }
  }
},
  // ..
`,
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped>
.v-btn {
  margin-right: 10px;
}
</style>